// GS PDP section hydrator — reloads stale section via Sections API
(function(){
  var SECTION_ID = 'template--26715799880061__custom_pdp';
  var el = document.getElementById('shopify-section-' + SECTION_ID);
  if(!el) return;
  // Check if section is stale (h1 empty or contains old cache)
  var h1 = el.querySelector('.product-title');
  if(h1 && h1.textContent.trim() !== '') return; // already fine
  // Fetch fresh section
  fetch(window.location.pathname + '?sections[]=' + encodeURIComponent(SECTION_ID))
    .then(function(r){ return r.json(); })
    .then(function(data){
      var html = data[SECTION_ID];
      if(!html) return;
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var newSect = tmp.firstElementChild;
      if(newSect) {
        el.replaceWith(newSect);
        // Init Shopify payment buttons
        if(window.Shopify && window.Shopify.PaymentButton) window.Shopify.PaymentButton.init();
      }
    })
    .catch(function(){});
})();
